var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4482 5.03369L9.59203 5.03369C8.20479 5.03369 7.0752 3.90408 7.0752 2.51685C7.0752 1.12961 8.20479 0 9.59203 0L40.4283 0C41.8156 0 42.9452 1.12961 42.9452 2.51685C42.965 3.90408 41.8354 5.03369 40.4482 5.03369Z",
    fill: "url(#paint0_linear_27_750)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9235 5.03369V20.5311C40.9235 29.0924 33.9873 36.0285 25.4261 36.0285H24.6532C19.5006 36.0285 14.9425 33.5117 12.1284 29.6671C11.1375 28.2997 10.3448 26.7737 9.84938 25.1288C9.39357 23.6821 9.15576 22.1364 9.15576 20.5311V5.03369L40.9235 5.03369Z",
    fill: "url(#paint1_linear_27_750)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8916 29.6671C37.8916 29.6869 37.9114 29.6869 37.9114 29.7067C43.8171 30.1427 46.869 27.3484 48.4148 24.6928C49.4651 22.9092 49.9804 20.8482 50.0002 18.7673C50.0002 17.8161 50.0002 16.5081 50.0002 15.1011C50.0002 14.4867 49.9407 13.8724 49.8218 13.2778C48.4544 6.83708 41.3002 7.31271 40.8841 7.35234V11.5933L40.9039 11.5537C40.9039 11.5537 45.8979 11.1375 45.7988 16.2703C45.8385 18.1332 45.7988 18.9259 45.7988 18.9259C45.7988 18.9259 46.3537 24.891 40.2499 25.2675C40.2301 25.2081 40.2103 25.1684 40.1904 25.109C39.6752 26.7737 38.8825 28.2996 37.8916 29.6671Z",
    fill: "url(#paint2_radial_27_750)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1086 29.6671C12.1086 29.6869 12.0888 29.6869 12.0888 29.7067C6.18312 30.1427 3.13119 27.3484 1.58541 24.6928C0.535077 22.9092 0.0198177 20.8482 0 18.7673C0 17.8161 0 16.5081 0 15.1011C0 14.4867 0.0594579 13.8724 0.178364 13.2778C1.54578 6.83708 8.69996 7.31271 9.11613 7.35234V11.5933L9.09632 11.5537C9.09632 11.5537 4.10228 11.1375 4.20136 16.2703C4.16173 18.1332 4.20136 18.9259 4.20136 18.9259C4.20136 18.9259 3.64647 24.891 9.75032 25.2675C9.77013 25.2081 9.78994 25.1684 9.80975 25.109C10.3448 26.7737 11.1177 28.2996 12.1086 29.6671Z",
    fill: "url(#paint3_radial_27_750)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7847 35.6917H21.9385V43.6385H27.7847V35.6917Z",
    fill: "url(#paint4_linear_27_750)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2726 43.6385H18.2326C18.0146 43.6385 17.8164 43.8169 17.8164 44.0547V46.8688H31.669V44.0547C31.6888 43.8367 31.4906 43.6385 31.2726 43.6385Z",
    fill: "url(#paint5_linear_27_750)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.179 11.0384L27.269 13.2382C27.4474 13.6147 27.8239 13.8724 28.2401 13.9318L30.6777 14.2885C31.728 14.4471 32.1442 15.7352 31.3911 16.4685L29.6273 18.1926C29.3301 18.4899 29.1913 18.9061 29.2508 19.3222L29.667 21.74C29.8453 22.7903 28.7553 23.583 27.8041 23.0876L25.6242 21.9382C25.2476 21.74 24.8116 21.74 24.4351 21.9382L22.2551 23.0876C21.3237 23.583 20.2139 22.7903 20.3923 21.74L20.8084 19.3222C20.8877 18.9061 20.749 18.4899 20.4319 18.1926L18.6682 16.4685C17.9151 15.7352 18.3312 14.4273 19.3816 14.2885L21.8191 13.9318C22.2353 13.8724 22.592 13.6147 22.7902 13.2382L23.8802 11.0384C24.3558 10.0872 25.7034 10.0872 26.179 11.0384Z",
    fill: "url(#paint6_linear_27_750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_750",
    x1: 7.08314,
    y1: 2.50824,
    x2: 42.5485,
    y2: 2.50824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2486,
    stopColor: "#FFC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFF744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#FFC836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_750",
    x1: 9.1384,
    y1: 20.5296,
    x2: 40.9161,
    y2: 20.5296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2486,
    stopColor: "#FFC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFDF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#FFC836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE961"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_27_750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1211 17.7253) scale(29.2273 29.2274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2486,
    stopColor: "#FFC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFDF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#FFC836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_27_750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.42118 15.3431) rotate(-180) scale(29.2273 29.2274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2486,
    stopColor: "#FFC936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFDF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#FFC836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_27_750",
    x1: 21.8415,
    y1: 39.6723,
    x2: 27.8633,
    y2: 39.6723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8944,
    stopColor: "#FFAB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_27_750",
    x1: 17.8652,
    y1: 43.851,
    x2: 31.8153,
    y2: 46.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8944,
    stopColor: "#FFAB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE64E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_27_750",
    x1: 19.7099,
    y1: 14.6647,
    x2: 31.2476,
    y2: 21.4028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#FFF3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.3420ec26a7a7f0082caf4b646f16407b.svg";
export { ForwardRef as ReactComponent };